import { generateUniqueKey, isEmpty } from '@sigma-frontend-libs/commons'

import overflow from '@/components/text/overflow'

const baseClass = 'radio-card'

function renderCircle(h) {
  return h(
    'div',
    {
      class: `${baseClass}__circle`
    }
  )
}
function renderLabel(h) {
  if (this.$_label) {
    return h(
      overflow,
      {
        class: `${baseClass}__label`,
        props: {
          value: this.$_label
        }
      }
    )
  }
}
function renderInfo(h, trigger) {
  if (trigger) {
    if (this.$_info) {
      return h(
        'div',
        {
          class: `${baseClass}__info`,
          domProps: { innerHTML: this.$_info }
        }
      )
    }
  }
}

function renderHolder(h) {
  return h(
    'div',
    {
      class: `${baseClass}__holder`
    },
    [
      renderCircle.call(this, h),
      renderLabel.call(this, h),
      renderInfo.call(this, h, isEmpty(this.$_label))
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: this.$_class,
      on: { click: this.clickHandler },
      key: generateUniqueKey()
    },
    [
      renderHolder.call(this, h),
      renderInfo.call(this, h, !isEmpty(this.$_label))
    ]
  )
}
